export default __webpack_public_path__ + "static/live-like-a-local-4-408756ce133e594f2a6f0c0b4fd9f286.png";